import React, { useEffect, useState } from 'react';
import SettingContainer from '../SettingContainer';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import { usePermission } from '../../../DataStore/PermissionContext';

const RolePermission = () => {
  const { getRolePermissions, rolePermissions, loading, setAccessRevoke, configRole } = usePermission();
  const [selected, setSelected] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    if(configRole) {
        getRolePermissions(configRole.role_id);
    }
  }, [configRole]);

  const toggleSelection = (key) => {
    setSelected((prev) =>
      prev.includes(key)
        ? prev.filter((item) => item !== key)
        : [...prev, key]
    );
  };

  const isSelected = (key) => selected.includes(key);

  const handleRevokePermission = () => {
    setAccessRevoke({
      show: true,
      accessIds: selected,
      callback: () => getRolePermissions(configRole.role_id),
    });
  };
  
  const menu = () => (
    <>
        <button type="button" tabIndex="0" className="dropdown-item" onClick={() => setSelected([])}>
            <i className="dropdown-icon fa fa-eraser"></i>
            <span>Clear Selection</span>
        </button>
         {selected.length > 0 && <button type="button" tabIndex="0" className="dropdown-item" onClick={handleRevokePermission}>
            <i className="dropdown-icon fa fa-user"></i>
            <span>Revoke Permissions</span>
        </button>}
   </>
  );

  const splitIntoColumns = (items, numCols = 2) => {
    const cols = Array.from({ length: numCols }, () => []);
    items.forEach((item, index) => {
      cols[index % numCols].push(item);
    });
    return cols;
  };

  const filteredPermissions = Array.isArray(rolePermissions) && rolePermissions.filter((perm) => {
    const q = searchQuery.toLowerCase();
    return (
      perm.permission_key.toLowerCase().includes(q) ||
      perm.description?.toLowerCase().includes(q)
    );
  }) || [];

  return (
    <SettingContainer
        title={`${configRole?.role_name} Permissions`}
        icon="fa fa-user-tag" 
        Menu={menu}
        >
      <div className="mb-3 mt-3 ml-3 mr-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search permissions..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {loading && <ActivityLoader />}

      {!loading && filteredPermissions.length === 0 && (
        <Notification message="No permissions found for this role." />
      )}

      {!loading && filteredPermissions.length > 0 && (
        <div className="row overflow-auto" style={{ maxHeight: '64vh' }}>
          {splitIntoColumns(filteredPermissions, 2).map((column, colIndex) => (
            <div key={colIndex} className="col-md-6 mb-3">
              <ul className="list-group list-group-flush">
                {column.map((perm) => {
                    const selected = isSelected(perm.access_id);
                    return (
                        <li
                        key={perm.permission_key}
                        onClick={() => toggleSelection(perm.access_id)}
                        className={`list-group-item d-flex justify-content-between align-items-start cursor-pointer ${
                            selected ? 'bg-light border-primary' : ''
                        }`}
                        style={{ cursor: 'pointer', borderLeft: selected ? '4px solid #0d6efd' : '4px solid transparent' }}
                        >
                        <div className="me-auto">
                            <strong className="d-block">{perm.permission_key}</strong>
                            <small className="text-muted">{perm.description}</small>
                        </div>
                        <div>
                            <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selected}
                            onChange={() => toggleSelection(perm.access_id)}
                            onClick={(e) => e.stopPropagation()} // Prevent checkbox click from double-toggling
                            />
                        </div>
                        </li>
                    );
                    })}

              </ul>
            </div>
          ))}
        </div>
      )}

    </SettingContainer>
  );
};

export default RolePermission;
